function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1 1l10 10m0-10L1 11",
  fill: "#c93879",
  stroke: "#bc241e",
  strokeLinecap: "round",
  strokeWidth: 2,
  fillRule: "evenodd"
});

var SvgIconCloseRed = function SvgIconCloseRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 12 12"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDEyIDEyIj48cGF0aCBkPSJNMSAxbDEwIDEwbTAtMTBMMSAxMSIgZmlsbD0iI2M5Mzg3OSIgc3Ryb2tlPSIjYmMyNDFlIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iMiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
export { SvgIconCloseRed as ReactComponent };